/* eslint-disable @typescript-eslint/no-empty-interface */
import React, { ReactElement } from "react";
import dynamic from "next/dynamic";
import { LoadingSkeleton } from "@kunduz/ui";
import { IContent } from "@kunduz/data-access-cms-api";

const DesktopLazyLoadedLeft = dynamic<any>(
  () => {
    return import("./desktopLeft").then((module) => module.DesktopLeft);
  },
  {
    ssr: false,
    loading: () => (
      <div style={{ display: "flex", gap: 12 }}>
        <LoadingSkeleton style={{ width: 150, height: 44 }} />
        <LoadingSkeleton style={{ width: 150, height: 44 }} />
        <LoadingSkeleton style={{ width: 150, height: 44 }} />
      </div>
    ),
  },
);

export const DesktopLeftLoader = (props: {
  headerType: "student" | "teacher" | "school";
  desktopLeftCmsData?: IContent.HeaderItemsResponse["components"];
}): ReactElement => {
  return <DesktopLazyLoadedLeft {...props} />;
};
